// -----------------------------------------------------------------------------
// Stylesheet order is significant and deliberately centralised here rather than
// scattered across components, because the cascade depends on it:
//
//   1. bpmn-js    - the modeller's own chrome. Imported here, not inside
//                   DiagramEditor / AzDoSettingsPage, so it can never land after
//                   index.css.
//   2. index.css  - Tailwind preflight, design tokens, and the .djs-* overrides
//                   that restyle the bpmn-js chrome. Must come last: those
//                   overrides match bpmn-js's own selectors at equal
//                   specificity, so they only win by source order.
//
// These are listed before `import App` so they are evaluated before anything the
// component tree pulls in.
// -----------------------------------------------------------------------------
import "bpmn-js/dist/assets/diagram-js.css";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";
import "./index.css";

import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Side-effect import, and the order matters: it reads `#addLibrary` out of the
// URL before React Router mounts and rewrites the location.
import "./lib/pendingLibrary";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(<App />);

reportWebVitals();
